<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useShopStore } from '@/store'

const shopStore = useShopStore()

// 本地开发环境下自动设置 shopState 为 true
onMounted(() => {
  // const isDevelopment = import.meta.env.DEV;
  // if (isDevelopment) {
  //   shopStore.setShopState(true);
  // }
})

// 未安装时显示，已安装才隐藏
const visible = computed(() => !shopStore.shopState)
console.log('shopState', shopStore.shopState);
</script>

<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 z-[9999] flex items-center justify-center bg-white/100">
      <div class="flex flex-col items-center gap-3">
        <span class="loader"></span>
        <span class="text-gray-700 text-sm">{{ shopStore.shopStateMsg || 'Loading...'}}</span>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.loader {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top-color: rgba(0, 0, 0, 0.6);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>

